import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Modal2 from 'components/modals/Modal2/Modal2';
import { ReactComponent as DangerIcon } from 'assets/icons/danger.svg';
import { AccountsContext } from '../../contexts/AccountsContext';

function ModalArchiveAccount() {
  const { formatMessage: t } = useIntl();
  const {
    isModalArchiveOpen,
    handleCloseModalArchive,
    archiveAccount,
    isArchiving,
  } = useContext(AccountsContext);
  return (
    <Modal2
      isOpen={isModalArchiveOpen}
      size="large"
      onClose={handleCloseModalArchive}
      icon={(<DangerIcon />)}
      loading={isArchiving}
      title={t({ id: 'modal.archiveAccount.title' })}
      subtitle={t({ id: 'modal.archiveAccount.subtitle' })}
      modalType="warning"
      actions={[
        {
          label: 'button.archive',
          showLoading: true,
          onClick: archiveAccount,
        },
        {
          label: 'button.cancel',
          type: 'secondaryOutline',
          showLoading: false,
          onClick: handleCloseModalArchive,
        },
      ]}
    />
  );
}

export default ModalArchiveAccount;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/ModalArchiveAccount/ModalArchiveAccount.jsx